import { render } from "./Navbar.vue?vue&type=template&id=6d581759&scoped=true&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=6d581759&scoped=true&lang=css"

import exportComponent from "G:\\Storage\\VSCodeProjects\\MineMCPay\\minemcpay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d581759"]])

export default __exports__